import { RawShareButton } from './ShareButton';
import { connectShare } from './ShareButton.connect';
import { RawShareButtonNext } from './ShareButtonNext';
import { RawSummary } from './Summary';
import { connectSummary } from './Summary.connect';

export const ShareButton = connectShare(RawShareButton);
ShareButton.displayName = 'ShareButton';

export const ShareButtonNext = connectShare(RawShareButtonNext);
ShareButtonNext.displayName = 'ShareButtonNext';

export const Summary = connectSummary(RawSummary);
Summary.displayName = 'Summary';
